import { QueryOperation, SearchQuery } from "../code/search-query/search-query";
import {
  buildSearchQuery,
  comboboxValue,
  numberValue,
  QueryFieldMapping,
} from "../code/search-query/query-mapper";
import { DataColumn } from "../controls/Data.default";
import { InputObject } from "../controls/default";

export interface CompanyRolesViewForm {
  readonly name: string;
  readonly description: string;
  readonly isManager: boolean;
  readonly company: InputObject;
  readonly domain: InputObject;
  readonly tenant: InputObject;
  readonly usersCount: number;
}

export const companyRolesViewColumns: DataColumn[] = [
  {
    title: "Name",
    key: "name",
    width: 192,
    sort: true,
    defaultSort: "asc",
    fixed: "left",
  },
  {
    title: "Description",
    key: "description",
    width: 192,
    sort: true,
  },
  {
    title: "Manager",
    key: "isManager",
    width: 192,
    sort: true,
  },
  {
    title: "Company",
    key: "companyName",
    width: 192,
    sort: true,
  },
  {
    title: "Industry",
    key: "companyDomainName",
    width: 192,
    sort: true,
  },
  {
    title: "Tenant",
    key: "tenantName",
    width: 192,
    sort: true,
  },

  {
    title: "Users",
    key: "usersCount",
    width: 192,
    sort: true,
    type: "badge",
  },
];

const rolesQueryMappings: QueryFieldMapping[] = [
  { formField: "name" },
  { formField: "description" },
  { formField: "isManager", operation: QueryOperation.Equal },
  { formField: "company", queryField: "companyUid", operation: QueryOperation.Equal, transform: comboboxValue },
  { formField: "domain", queryField: "companyDomainUid", operation: QueryOperation.Equal, transform: comboboxValue },
  { formField: "tenant", queryField: "tenantUid", operation: QueryOperation.Equal, transform: comboboxValue },
  { formField: "usersCount", operation: QueryOperation.Equal, transform: numberValue },
];

export const mapCompanyRolesViewQuery = (values: CompanyRolesViewForm): SearchQuery =>
  buildSearchQuery(values, rolesQueryMappings);
